// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/static/icons/burger.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("static/icons/vk_bej.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("static/icons/vk_black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("static/icons/instagram_bej.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("static/icons/instagram_black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("static/icons/telegram_bej.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("static/icons/telegram_black.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*export const COLOURS = {*/
/*  BLUE: "#05386B",*/
/*  DARK_GREEN: "#379683",*/
/*  GREEN: "#5CDB95",*/
/*  LIGHT_GREEN: "#8EE4AF",*/
/*  BEJ: "#EDF5E1" //rgb(237, 245, 225)*/
/*}*/


* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  height: 1000px;
  width: 100%;
  font-family: 'Segoe UI Black', sans-serif;
  background: #EDF5E1;

}

.App {
  text-align: center;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /*font-size: calc(10px + 2vmin);*/
  color: white;
}

.slider {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  width: 100%;
}

.slider--content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100vh;
}

.slider--feature {
  text-align: center;
}

.feature--title {
  font-size: 2.5rem;
  color: #fff;
  text-transform: uppercase;
  font-weight: 700;
}

.feature--text {
  font-size: 1rem;
  color: #fff;
  margin: 1rem 0;
}

.slider__btn-right,
.slider__btn-left {
  background-color: rgba(0, 0, 0, .1);
  height: 70%;
  max-width: 80px;
  width: 10%;
  min-width: 50px;
  border: none;
  outline: none;
  font-size: 4rem;
  color: #eee;
  cursor: pointer;
  transition: .4s ease-out;
  box-shadow: 0 0 10px 10px black;
}

.fas {
  width: 20px;
  height: 20px;
  border: solid white;
  border-radius: 5px;
  border-width: 0 6px 6px 0;
  display: inline-block;
  padding: 3px;
}

.fa-angle-left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.fa-angle-right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.slider__btn-right:hover,
.slider__btn-left:hover {
  background-color: rgba(0, 0, 0, .3);
  transition: .4s ease-in;
}

.feature__btn {
  background: #fff;
  text-transform: uppercase;
  color: #444;
  border: 1px solid #444;
  outline: none;
  font-weight: 700;
  padding: 0.8rem 2rem;
  cursor: pointer;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.fadeIn {
  animation: fadeIn 0.5s;
}

/*changes the navbar toggler icon from default*/
.navbar-toggler-icon{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.navHref:hover{
  color: black;
  transition: all .3s;
  cursor: pointer;
}

.activeLink {
  border-bottom: 2px solid #EDF5E1;
}

.iconDiv {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}

.iconDivCent {
  width: 50px;
  height: 50px;
  margin-right: 10px;
  margin-left: 10px;
}

.vkDiv {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  background-size: contain;
  transition: all .3s;
}

.vkDiv:hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
  background-size: contain;
  transition: all .3s;
}

.instDiv {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat;
  background-size: contain;
  transition: all .3s;
}

.instDiv:hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat;
  background-size: contain;
  transition: all .3s;
}

.telegramDiv {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat;
  background-size: contain;
  transition: all .3s;
}

.telegramDiv:hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat;
  background-size: contain;
  transition: all .3s;
}

.aboutItem {
  background-color: #378CE3;
  border-radius: 50px;
  padding: 10px 10px;
  margin: 5px;
}

.hoverable {
  cursor: pointer;
}

.hoverableImgItem:hover {
  transform: scale(1.05);
  transition: .2s;
}

.hoverableItemPreview:hover {
  background-color: #a2cdf3;
  border: solid #116fc2;
  transition: .2s;
}

.divMainSlider {
  box-shadow: 10px #116fc2;
  border-radius: 10px;
  width: auto;
  min-width: 500px;
  height: 400px;
  overflow: hidden;
  position: relative;
}

@media screen and (max-width: 800px) {
    .divMainSlider {
      min-width: 300px;
      height: 200px;
      max-width: 300px;
    }
  }

.border {
  border-radius: 10px;
  overflow: hidden;
  border: 3px solid #116fc2;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B,qBAAqB;AACrB,2BAA2B;AAC3B,sBAAsB;AACtB,4BAA4B;AAC5B,wCAAwC;AACxC,IAAI;;;AAGJ;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yCAAyC;EACzC,mBAAmB;;AAErB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;EACnC,WAAW;EACX,eAAe;EACf,UAAU;EACV,eAAe;EACf,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;;EAEE,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,yDAAqD;AACvD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6DAAoD;EACpD,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,6DAAsD;EACtD,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,6DAA2D;EAC3D,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,6DAA0D;EAC1D,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,6DAA4D;EAC5D,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;IACI;MACE,gBAAgB;MAChB,aAAa;MACb,gBAAgB;IAClB;EACF;;AAEF;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B","sourcesContent":["/*export const COLOURS = {*/\n/*  BLUE: \"#05386B\",*/\n/*  DARK_GREEN: \"#379683\",*/\n/*  GREEN: \"#5CDB95\",*/\n/*  LIGHT_GREEN: \"#8EE4AF\",*/\n/*  BEJ: \"#EDF5E1\" //rgb(237, 245, 225)*/\n/*}*/\n\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  height: 1000px;\n  width: 100%;\n  font-family: 'Segoe UI Black', sans-serif;\n  background: #EDF5E1;\n\n}\n\n.App {\n  text-align: center;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  /*font-size: calc(10px + 2vmin);*/\n  color: white;\n}\n\n.slider {\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100vh;\n  width: 100%;\n}\n\n.slider--content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 100vh;\n}\n\n.slider--feature {\n  text-align: center;\n}\n\n.feature--title {\n  font-size: 2.5rem;\n  color: #fff;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n\n.feature--text {\n  font-size: 1rem;\n  color: #fff;\n  margin: 1rem 0;\n}\n\n.slider__btn-right,\n.slider__btn-left {\n  background-color: rgba(0, 0, 0, .1);\n  height: 70%;\n  max-width: 80px;\n  width: 10%;\n  min-width: 50px;\n  border: none;\n  outline: none;\n  font-size: 4rem;\n  color: #eee;\n  cursor: pointer;\n  transition: .4s ease-out;\n  box-shadow: 0 0 10px 10px black;\n}\n\n.fas {\n  width: 20px;\n  height: 20px;\n  border: solid white;\n  border-radius: 5px;\n  border-width: 0 6px 6px 0;\n  display: inline-block;\n  padding: 3px;\n}\n\n.fa-angle-left {\n  transform: rotate(135deg);\n  -webkit-transform: rotate(135deg);\n}\n\n.fa-angle-right {\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n}\n\n.slider__btn-right:hover,\n.slider__btn-left:hover {\n  background-color: rgba(0, 0, 0, .3);\n  transition: .4s ease-in;\n}\n\n.feature__btn {\n  background: #fff;\n  text-transform: uppercase;\n  color: #444;\n  border: 1px solid #444;\n  outline: none;\n  font-weight: 700;\n  padding: 0.8rem 2rem;\n  cursor: pointer;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.fadeIn {\n  animation: fadeIn 0.5s;\n}\n\n/*changes the navbar toggler icon from default*/\n.navbar-toggler-icon{\n  background-image: url(\"/src/static/icons/burger.svg\");\n}\n\n.navHref:hover{\n  color: black;\n  transition: all .3s;\n  cursor: pointer;\n}\n\n.activeLink {\n  border-bottom: 2px solid #EDF5E1;\n}\n\n.iconDiv {\n  width: 50px;\n  height: 50px;\n  margin-right: 20px;\n}\n\n.iconDivCent {\n  width: 50px;\n  height: 50px;\n  margin-right: 10px;\n  margin-left: 10px;\n}\n\n.vkDiv {\n  background: url(\"static/icons/vk_bej.svg\") no-repeat;\n  background-size: contain;\n  transition: all .3s;\n}\n\n.vkDiv:hover {\n  background: url(\"static/icons/vk_black.svg\") no-repeat;\n  background-size: contain;\n  transition: all .3s;\n}\n\n.instDiv {\n  background: url(\"static/icons/instagram_bej.svg\") no-repeat;\n  background-size: contain;\n  transition: all .3s;\n}\n\n.instDiv:hover {\n  background: url(\"static/icons/instagram_black.svg\") no-repeat;\n  background-size: contain;\n  transition: all .3s;\n}\n\n.telegramDiv {\n  background: url(\"static/icons/telegram_bej.svg\") no-repeat;\n  background-size: contain;\n  transition: all .3s;\n}\n\n.telegramDiv:hover {\n  background: url(\"static/icons/telegram_black.svg\") no-repeat;\n  background-size: contain;\n  transition: all .3s;\n}\n\n.aboutItem {\n  background-color: #378CE3;\n  border-radius: 50px;\n  padding: 10px 10px;\n  margin: 5px;\n}\n\n.hoverable {\n  cursor: pointer;\n}\n\n.hoverableImgItem:hover {\n  transform: scale(1.05);\n  transition: .2s;\n}\n\n.hoverableItemPreview:hover {\n  background-color: #a2cdf3;\n  border: solid #116fc2;\n  transition: .2s;\n}\n\n.divMainSlider {\n  box-shadow: 10px #116fc2;\n  border-radius: 10px;\n  width: auto;\n  min-width: 500px;\n  height: 400px;\n  overflow: hidden;\n  position: relative;\n}\n\n@media screen and (max-width: 800px) {\n    .divMainSlider {\n      min-width: 300px;\n      height: 200px;\n      max-width: 300px;\n    }\n  }\n\n.border {\n  border-radius: 10px;\n  overflow: hidden;\n  border: 3px solid #116fc2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
